import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const NumberSpan = styled.span`
  margin-left: 0.6ch;
  font-weight: ${Variables.fontWeightRegular};
`;
